import { useState, useEffect } from "react"
import { GoogleMap, Marker } from "@react-google-maps/api"
import { isValidImageURL } from "../../lib/media"
import { useDecision } from "@optimizely/react-sdk"

export const MapDisplay = (props) => {
    const [decisionCustomPins] = useDecision('custom-pins')
    const { 
        center = { lat: 43.6426, lng: -79.3871 }, 
        withMarker, 
        markerPath, 
        markerProps, 
        ...mapProps 
    } = props
    const [markerIcon, setMarkerIcon] = useState(undefined)

    useEffect(() => {
        const icon = decisionCustomPins?.enabled
            ? markerPath
            : null
        isValidImageURL(
            icon,
            valid => {
                if (valid && window?.google?.maps) {
                    setMarkerIcon({
                        url: icon,
                        scaledSize: new window.google.maps.Size(26, 32),
                    })
                } else {
                    // If custom marker is invalid/unavailable, display google maps default pin
                    setMarkerIcon(undefined)
                }
            }
        )
    }, [markerPath, decisionCustomPins?.enabled])

    return (
        <GoogleMap
            mapContainerStyle={{ width: "100%", height: "300px" }}
            center={center}
            zoom={15}
            {...mapProps}
        >
            {
                withMarker
                    ? (
                        <Marker
                            position={center}
                            icon={markerIcon}
                            {...markerProps}
                        />
                    )
                    : null
            }
        </GoogleMap>
    )
}

export default MapDisplay
